export class EnumApiPartner {
    constructor() {
        /**
         * @dec
         * @method post 查询企业扩展信息
         * @params
         */
        this.common_partner_findExpand = {
            url: '/api/gateway/partner-bff/api/partnerExpand/findByBusinessCode',
            method: 'post',
        };
        /**
         * @dec
         * @method post 保存企业扩展信息
         * @params
         */
        this.common_partner_saveExpand = {
            url: '/api/gateway/partner-bff/api/partnerExpand/saveOrUpdatePartnerExpand',
            method: 'post',
        };
        /**
         * @dec
         * @method post 保存企业经营信息
         * @params
         */
        this.common_partner_saveOperate = {
            url: '/api/gateway/partner-bff/api/partnerOperate/saveOrUpdateOperate',
            method: 'post',
        };
        /**
         * @dec
         * @method get 查询企业经营信息
         * @params
         */
        this.common_partner_findOperate = {
            url: '/api/gateway/partner-bff/api/partnerOperate/findByBusinessCode',
            method: 'post',
        };
        /**
         * @dec
         * @method post 更新企业组织结构信息
         * @params
         */
        this.partner_update_organization = {
            url: '/api/gateway/partner-bff/api/partnerStructure/saveOrUpdateStructure',
            method: 'post',
        };
        /**
         * @dec
         * @method get 查询企业组织结构信息
         * @params
         */
        this.partner_get_organization = {
            url: '/api/gateway/partner-bff/api/partnerStructure/findByBusinessCode',
            method: 'post',
        };
        /**
         * @method get 根据输入的K查询企业身份
         * @params
         */
        this.partner_partnerIdentity = {
            url: '/api/gateway/partner-bff/api/partnerIdentity/findChannelPartnerIdentity',
            method: 'get',
        };
        /**
         * @method get 根据身份id查询企业身份详情
         * @params
         */
        this.partner_partnerIdentity_findInfo = {
            // url: '/api/gateway/partner-bff/api/partnerIdentity/findUserPartnerIdentity'
            url: '/api/gateway/partner-bff/api/partnerIdentity/findCurrentPartnerIdentity',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec
         * @method post 加入组织申请提交
         * @params
         */
        this.partner_partnerIdentityCreate = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/create',
            method: 'post',
        };
        /**
         * @dec
         * @method post 再次加入组织申请
         * @params
         */
        this.partner_partnerIdentityReapply = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/reapply',
            method: 'post',
        };
        /**
         * @dec
         * @method post 组织申请列表
         * @params
         */
        this.partner_organizationPage = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/page4User',
            method: 'post',
        };
        /**
         * @dec
         * @method post 我的组织管理员审核列表
         * @params
         */
        this.partner_organization_ApplyPage = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/page4ChannelAdmin',
            method: 'post',
        };
        /**
         * @dec
         * @method post 加入组织申请审核
         * @params
         */
        this.partner_save_organizationApply = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/examine',
            method: 'post',
        };
        // /**
        //  * @dec
        //  * @method post 我的企业身份列表
        //  * @params
        //  */
        // readonly partner_get_identity_list: IAjaxConfig = {
        //   url: '/api/gateway/partner-bff/api/partnerIdentity/pageUserPartnerIdentity',
        //   method: 'post',
        // };
        /**
         * @dec
         * @method post 查询企业身份列表(站在企业的角度)
         * @params
         */
        this.partner_get_identity_list = {
            url: '/api/gateway/partner-bff/api/partnerIdentity/pageChannelIdIdentityWithArea',
            method: 'post',
        };
        /**
         * @dec
         * @method post 我加入的组织申请列表(分页查询)
         * @params
         */
        this.partner_get_org_apply_list = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/page4User',
            method: 'post',
        };
        /**
         * @dec
         * @method post 查询我的企业身份列表
         * @params
         */
        this.partner_get_partner_identity_list = {
            url: '/api/gateway/partner-bff/api/partnerIdentity/pageUserPartnerIdentity',
            method: 'post',
        };
        /**
         * @dec
         * @method post 编辑地址
         * @params
         */
        this.partner_update_address = {
            url: '/api/gateway/partner-bff/api/partnerIdentityArea/saveOrUpdateByIdentityId',
            method: 'post',
        };
        /**
         * @dec
         * @method post 我的组织成员
         * @params
         */
        this.partner_employee_page = {
            url: '/api/gateway/partner-bff/api/employee/pageChannelEmployee',
            method: 'post',
        };
        /**
         * @method get 获取当前身份下的角色
         * @params
         */
        this.partner_get_identity_role = {
            url: '/api/gateway/partner-bff/api/partnerEmployeeRelation/findUserChannelRoleContent',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @method get 获取当前身份信息
         * @params
         */
        this.partner_get_identity_info = {
            url: '/api/gateway/partner-bff/api/partnerIdentity/findUserIdAndIdentityByToken',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @method get 再次申请加入组织
         * @params
         */
        this.partner_re_apply_org = {
            url: '/api/gateway/partner-bff/api/employeeApplyIdentity/reapply',
            method: 'post',
        };
        /**
         * @dec
         * @method post 删除我的组织成员
         * @params
         */
        this.partner_employee_remove = {
            url: '/api/gateway/partner-bff/api/employee/removeEmployeeById',
            method: 'post',
        };
        /**
         * @dec
         * @method post 修改我的组织成员角色
         * @params
         */
        this.partner_employee_editRole = {
            url: '/api/gateway/partner-bff/api/partnerEmployeeRelation/updateByChannelIdAndEmployeeId',
            method: 'post',
        };
        /**
         * @dec
         * @method get 获取角色
         * @params
         */
        this.partner_get_role = {
            url: '/api/gateway/permission/role/search',
            method: 'get',
        };
        /**
         * @dec 合作身份列表
         * @method get
         * @params
         */
        this.partner_identityListAll = {
            url: '/api/gateway/partner-bff/api/identityCodeTable/listIdentityCodeTableShow',
            method: 'get',
        };
        // /api/identityCodeTable/listIdentityCodeTableShow
        // /**
        //  * @dec 合作身份列表
        //  * @method get
        //  * @params
        //  */
        // readonly partner_identityListAll: IAjaxConfig = {
        //   url: '/api/gateway/partner-bff/api/identityCodeTable/listAll',
        //   method: 'get',
        // };
        // /**
        //  * @dec 已有合作身份列表
        //  * @method get
        //  * @params
        //  */
        // readonly partner_have_identityList: IAjaxConfig = {
        //   url: '/api/gateway/partner-bff/api/partnerApplyIdentity/listExcludeIdentity',
        //   method: 'get',
        // };
        /**
         * @dec 身份申请列表
         * @method post
         * @params
         */
        this.partner_applyIdentity_page = {
            url: '/api/gateway/partner-bff/api/partnerApplyIdentity/list4Page',
            method: 'post',
        };
        /**
         * @dec 申请身份
         * @method post
         * @params
         */
        this.partner_applyIdentity_create = {
            url: '/api/gateway/partner-bff/api/partnerApplyIdentity/create',
            method: 'post',
        };
        /**
         * @dec 查询 企业相关信息是否完善
         * @method get
         * @params
         */
        this.partner_findBusiness_perfect = {
            url: '/api/gateway/partner-bff/api/preconditions4Signing/findByBusinessCode',
            method: 'get',
        };
        /**
         * @dec 查询 变更身份列表
         * @method post
         * @params
         */
        this.partner_changelog_list = {
            url: '/api/gateway/partner-bff/api/partnerChangeIdentity/list4PageByBCode',
            method: 'post',
        };
        /**
         * @dec 变更身份 操作
         * @method post
         * @params
         */
        this.partner_change_identity = {
            url: '/api/gateway/partner-bff/api/partnerChangeIdentity/create',
            method: 'post',
        };
        /**
         * @dec 变更身份 重新申请
         * @method get
         * @params
         */
        this.partner_change_identity_reapply = {
            url: '/api/gateway/partner-bff/api/partnerChangeIdentity/reapplication',
            method: 'get',
        };
        /**
         * @dec 根据B码查询企业ISG信息
         * @method post
         * @params
         */
        this.partner_find_isgInfo = {
            url: '/api/gateway/partner-bff/api/partnerISGInfo/findByBusinessCode',
            method: 'post',
        };
        /**
         * @dec B码更新企业ISG信息
         * @method post
         * @params
         */
        this.partner_save_isgInfo = {
            url: '/api/gateway/partner-bff/api/partnerISGInfo/saveOrUpdateISGInfo',
            method: 'post',
        };
        /**
       * @method get 根据身份id查询企业身份详情 (新，合并l2后)
       * @params
       */
        this.partner_partnerIdentity_findInfo_new = {
            url: '/api/gateway/partner-bff/v3/api/partnerIdentity/findCurrentPartnerIdentity',
            method: 'get',
            loading: true,
            awaitAuthenticated: true,
        };
        /**
     * @dec
     * @method post 获取身份list(新，合并l2后)
     * @params
     */
        this.partner_get_partnerIdentity_new = {
            url: '/api/gateway/partner-bff/v3/api/partnerIdentity/listChannelByUserId4Choice',
            method: 'get',
            loading: true,
            // awaitAuthenticated: false,
        };
        /**
     * @dec 登录后是否需要选择身份
     * @method get
     * @params
     */
        this.accountsvr_identity_ischoose = {
            url: '/api/gateway/idaas/v1/identity/choose/judge',
            method: 'get',
        };
        /**
       * @dec 获取用户信息
       * @method get
       * @params
       */
        this.accountsvr_get_userinfo = {
            url: '/api/gateway/idaas/v1/users/user/info/get',
            method: 'get',
            loading: true,
            awaitAuthenticated: true,
        };
    }
}
